import { computed } from "vue";
import usePiniaStore from "@/store/index";

/**
 * 权限判断 Hook
 * @param permissionKey 单个权限字符串或权限字符串数组
 * @returns 一个计算属性，如果用户拥有指定权限则为 true，否则为 false
 */
export function usePermissions(permissionKey: string | string[]) {
  const { userStore } = usePiniaStore();

  return computed(() => {
    const roles = userStore.roles;
    // 确保 roles 是一个数组
    if (!roles || !Array.isArray(roles)) {
      console.warn(
        "usePermissions: userStore.roles is not an array or is undefined."
      );
      return false;
    }

    if (Array.isArray(permissionKey)) {
      // 如果传入的是权限数组，则需要所有权限都满足
      return permissionKey.every((key) => roles.includes(key));
    }
    // 如果传入的是单个权限字符串
    return roles.includes(permissionKey);
  });
}
